import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopPreCallForm from './_PopPreCallForm';
function Attendance() {
  const navigate = useNavigate();
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '담당학생 전체', value: 0},
    {title: '당일 출석부', value: 1},
    {title: '출석 미체크 ', value: 2},
    {title: '결석', value: 3},
    {title: '사전통화 미등록', value: 4}
  ];
  const [modalPreCallForm, setModalPreCallForm] = useState(false);
  return (
    <main className="com_container com_attendance">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_11">출석부</h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <span className="com_check_box">
                <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                <label htmlFor="chk010">내 출석부</label>
              </span>
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <span className="bar" />
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <div className="com_red_txt">* 수업 시작 24시간 전부터 수업 시작 전까지만 변경 신청 가능, 지연 신청 시 포인트 차감 됩니다.</div>
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="140" />
                <col width="150" />
                <col width="90" />
                <col width="150" />
                <col width="120" />
                <col width="90" />
                <col width="90" />
                <col width="90" />
                <col width="90" />
                <col width="auto" />
                <col width="140" />
                <col width="90" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>수업일시</th>
                  <th>사전통화</th>
                  <th>학생명</th>
                  <th>전화번호</th>
                  <th>수업장소</th>
                  <th>수업상세</th>
                  <th>담임명</th>
                  <th>회차 / T</th>
                  <th>진행 회차</th>
                  <th>출석 현황</th>
                  <th>
                    다음 수업일 &nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>출석</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>45</td>
                  <td>2023, 05, 11 12:30</td>
                  <td>
                    <button onClick={() => setModalPreCallForm(true)} className="btn_link blue">
                      통화 등록
                    </button>
                  </td>
                  <td>
                    <button onClick={() => navigate('/Student/Detail/Attendance')} className="name btn_link">
                      김길동111
                    </button>
                  </td>
                  <td>
                    학 : 010-1234-1234
                    <br />
                    모 : 010-1324-3212
                    <br />부 : 010-1234-1234
                  </td>
                  <td>경기도 수원시</td>
                  <td>수학영역</td>
                  <td>김담임103</td>
                  <td>3 / 2T</td>
                  <td className="td_point">첫수업</td>
                  <td>출석5 | 결석2 | 조퇴5 | 연기5</td>
                  <td>2023, 05, 11 12:30</td>
                  <td>
                    <button className="com_btn gray xxs">출석</button>
                  </td>
                </tr>
                {[...Array(6)].map((i, idx) => (
                  <tr key={idx}>
                    <td>45</td>
                    <td>2023, 05, 11 12:30</td>
                    <td>
                      <button onClick={() => setModalPreCallForm(true)} className="btn_link">
                        2023, 05, 12 12:30
                      </button>
                    </td>
                    <td>
                      <button onClick={() => navigate('/Student/Detail/Attendance')} className="name btn_link">
                        김길동111
                      </button>
                    </td>
                    <td>
                      학 : 010-1234-1234
                      <br />
                      모 : 010-1324-3212
                      <br />부 : 010-1234-1234
                    </td>
                    <td>경기도 수원시</td>
                    <td>수학영역</td>
                    <td>
                      <button className="btn_link">김담임103</button>
                    </td>
                    <td>3 / 2T</td>
                    <td>10</td>
                    <td>출석5 | 결석2 | 조퇴5 | 연기5</td>
                    <td>2023, 05, 11 12:30</td>

                    <td className="td_point">결석</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Paging />
          </section>
        </section>
      </div>
      <PopPreCallForm open={modalPreCallForm} close={() => setModalPreCallForm(false)} />
    </main>
  );
}

export default Attendance;
